var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationCoachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 5.66699C13 4.34091 12.4732 3.06914 11.5355 2.13146C10.5979 1.19378 9.32608 0.666992 8 0.666992C6.67392 0.666992 5.40215 1.19378 4.46447 2.13146C3.52678 3.06914 3 4.34091 3 5.66699C3 11.5003 0.5 13.167 0.5 13.167H15.5C15.5 13.167 13 11.5003 13 5.66699Z",
    fill: "#68A14B",
    stroke: "#68A14B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.44193 16.5C9.29542 16.7526 9.08513 16.9622 8.83211 17.1079C8.5791 17.2537 8.29224 17.3304 8.00026 17.3304C7.70828 17.3304 7.42142 17.2537 7.1684 17.1079C6.91539 16.9622 6.7051 16.7526 6.55859 16.5",
    stroke: "#68A14B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCoachIcon);
export default __webpack_public_path__ + "static/media/notification-coach-icon.ffa29984f3e8a2b6b6818794bfb2a2e7.svg";
export { ForwardRef as ReactComponent };